'use client';

import { Skeleton } from '@/components/Skeleton';
import { useDevice } from '@/hooks/device';

export default function LobbySliderSkeleton() {
  const { isMobileDevice } = useDevice();

  return (
    <Skeleton.Container>
      <Skeleton.Rect height={isMobileDevice ? 984 : 642} />
    </Skeleton.Container>
  );
}
